<template>
  <ModalDefault modal_id="passwordUserModal"
                header="y"
                size="modal-md modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_827')"
                footer="y"
                icon="bx bxs-key mr-1">
    <div class="px-2 py-2 pb-3" slot="body">
      <div v-if="password_error" class="col-12 text-center px-2">
        <div class="animated--grow-in alert alert-danger rounded-0">
          <span>{{ getTranslations('expression_828') }}</span>
        </div>
      </div>
      <form @submit.prevent="updatePassword(users.user)">
        <div class="d-flex">
          <div class="cursor-default w-100" style="align-items: center; align-self: center;">
            <div class="d-block pt-2 px-2">
              <div class="col-12 px-0">
                <label class="mb-0">
                  {{ getTranslations('expression_829') }}
                </label>
                <div class="input-group mb-4">
                  <input ref="edituser_password"
                         type="password"
                         v-model="change_password"
                         class="input_forms form-control"
                         id="edituser_password">
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div slot="footer" class="px-2 py-2 d-flex">
      <div>
          <span type="submit" @click.prevent="updatePassword(users.user)"
                class="shadow-sm cursor_pointer animated--grow-in btn-primary text-white py-2 px-3">
            <span class="">{{ getTranslations('expression_830') }}</span>
          </span>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import {mapGetters, mapState} from "vuex";
import $ from "jquery";

export default {
  name: "ModalUserPassword",
  components: {
    ModalDefault,
  },
  data(){
    return {
      change_password: '',
      password_error: false,
    }
  },
  async mounted() {
    $('#passwordUserModal').on('hidden.bs.modal', () => {
      this.password_error = false
    })
    $('#passwordUserModal').on('shown.bs.modal', () => {
      this.$refs.edituser_password.focus()
    })
  },
  computed: {
    ...mapState(['users', 'channels']),
    ...mapGetters([])
  },
  methods: {
    updatePassword(payload) {
      if (this.change_password.length > 0) {
        this.$store.dispatch('updateUser', {id: payload.id, change_password: this.change_password})
        this.change_password = ''
        this.password_error = false
        $('#passwordUserModal').modal('hide')
      } else {
        this.password_error = true
        this.$refs.edituser_password.focus()
      }
    },
  }
}
</script>

<style scoped>

</style>
